/** Bundled TRUE ARTIS logo (overridden by hospital.logoUrl from admin branding when set). */
export const DEFAULT_HOSPITAL_LOGO_PATH = '/investor/true-artis-logo-light.svg';

export function resolveHospitalLogoSrc(
  hospital?: { logoUrl?: string | null; group?: { logoUrl?: string | null } } | null
): string {
  const tenant = hospital?.logoUrl?.trim() || hospital?.group?.logoUrl?.trim();
  return tenant || DEFAULT_HOSPITAL_LOGO_PATH;
}
